import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1>Jonathan Camargo</h1>
            </header>
            <div className="content">
                <p>Ph.D. in Robotics | Georgia Institute of Technology <br></br> Visiting Researcher | Reality Labs, Meta</p>
                <ul className="actions">
                    <li><a href="cv" className="button next scrolly">CV</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner
